import { render, staticRenderFns } from "./MasterPriceCategoriesDetails.vue?vue&type=template&id=eb232f7a"
import script from "./MasterPriceCategoriesDetails.vue?vue&type=script&lang=js"
export * from "./MasterPriceCategoriesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports